import React from 'react';
import Card from './Card';

export interface StatsCardProps {
  title: string;
  value: string | number;
  description?: string;
  color?: 'bright-blue' | 'purple' | 'fleet-monitor-blue' | 'dark-blue' | 'green' | 'sky-blue';
  loading?: boolean;
  trend?: {
    value: number;
    direction: 'up' | 'down';
    color?: 'green' | 'red' | 'gray';
  };
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  description,
  color = 'bright-blue',
  loading = false,
  trend,
  icon,
  onClick,
  className = '',
}) => {
  return (
    <Card
      variant="stats"
      size="md"
      hover={true}
      clickable={!!onClick}
      loading={loading}
      onClick={onClick}
      className={className}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-3xl onyx-bold mb-2" style={{ color: `var(--onyx-${color})` }}>
            {value}
          </div>
          <div className="text-lg onyx-subtitle text-gray-900 mb-1">{title}</div>
          {description && <div className="text-sm text-gray-600 onyx-body">{description}</div>}
          {trend && (
            <div
              className={`flex items-center mt-2 text-sm onyx-subtitle ${
                trend.color === 'green'
                  ? 'text-onyx-green'
                  : trend.color === 'red'
                    ? 'text-onyx-red'
                    : 'text-gray-500'
              }`}
            >
              <span className="mr-1">{trend.direction === 'up' ? '↗' : '↘'}</span>
              {Math.abs(trend.value)}%
            </div>
          )}
        </div>

        {icon && (
          <div className="flex-shrink-0 ml-4">
            <div className="w-8 h-8 text-gray-400">{icon}</div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatsCard;
